import "./Nav.css";
import brand from "../../Images/Brand/logo.png";
import { useLocation, useNavigate } from "react-router-dom";
const Nav = ({ setMenuBar, menuBar }) => {
    // const Navigate = useNavigate();

    const location = useLocation();
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        if (location.pathname === path) {
            window.location.reload(); // refresh if same page
        } else {
            navigate(path);
        }
    };

    return (
        <>
            <div className="navigation">
                {menuBar === false &&
                    <>
                        {/* <div className="nav__left-top-white"></div>
                        <div className="rightNavTopAll"></div> */}
                    </>
                }
                <div className="left__bottom-white"></div>
                <div className="left__bottom-main"></div>




                <div className="leftNav">
                    <div className="logo">
                        <img src={brand} alt="logo" />
                        <div onClick={() => navigate("/")} className="logoTitle">
                            <span>Bhanubhakta</span>
                            <span>Thevisualdesigner</span>
                        </div>
                    </div>
                    <div className="available">
                        <div className="theme">
                            <div className="themeChanger">
                                <div className="themeCircle">

                                </div>
                            </div>
                        </div>
                        <div className="availableBox">
                            <span></span>
                            <div className="availableText">
                                Available
                            </div>
                        </div>
                    </div>
                    <span className="leftNavSpan"></span>
                    <span className="leftNavSpan2"></span>
                </div>

                <div className="rightNav">
                    <div onClick={() => setMenuBar(!menuBar)} className="menuBtn">
                        {menuBar ?
                            <>
                                <span>Close</span>
                                <span>Close</span>
                            </>

                            :
                            <>
                                <span>Menu</span>
                                <span>Menu</span>
                            </>
                        }
                    </div>

                    <span className="nav__top-right-white"></span>
                    <span
                        style={menuBar ? { backgroundColor: "#2c2c2d" } : { backgroundColor: "#F6F6F6" }} className={`nav__top-right-default ${menuBar ? "active" : ""}`}
                    ></span>

                </div>
            </div>
            <div style={menuBar ? { backgroundColor: "#ffffffff" } : { backgroundColor: "#ffffffff" }} className="menuMiddleRightFull"></div>
            <div style={menuBar ? { backgroundColor: "#2c2c2d" } : { backgroundColor: "#F6F6F6" }} className="menuMiddleRight"></div>

            {menuBar &&
                <>
                    <div className={menuBar ? "menuBar" : "menuBarClose"}>
                        <div onClick={() => handleNavigate("/about")} className="LinkForMenu">
                            About
                        </div>
                        <div onClick={() => handleNavigate("/works")} className="LinkForMenu">
                            Work
                        </div>
                        <div onClick={() => handleNavigate("/contact")} className="LinkForMenu">
                            Contact
                        </div>
                        <div onClick={() => handleNavigate("/blogs")} className="LinkForMenu">
                            Blogs
                        </div>
                    </div>

                </>
            }


        </>
    )
}
export default Nav;